import { gql } from '@apollo/client/core'
  
const summaryReturnedFields = `
        name
        path
        _id
        isActive
`

/**
 * SUMMARY QUERY
 * Fetches lightweight info for list view
 */
export const SUMMARY_QUERY = gql`
  query OrganisationSummary {
    items: organisationsByFields {
      ${summaryReturnedFields}
    }
  }
`

/**
 * DETAIL QUERY
 * Fetches full info for editing
 */
export const DETAIL_QUERY = gql`
  query OrganisationDetail($id: MongoID!) {
    item: organisationById(_id: $id) {
    _id
      logo
      name
      path
      archived
      isActive
      address { 
        first
        second
        third
        fourth
        fifth
        sixth
     }
    }
  }
`

/**
 * CREATE MUTATION
 */
export const CREATE_MUTATION = gql`
  mutation OrganisationCreateOne($record: CreateOneOrganisationInput!) { 
    saveItem: organisationCreateOne(record: $record) {
     recordId
     record {
      ${summaryReturnedFields}
    } 
    } }`

/**
 * UPDATE MUTATION
 * Note: The returned fields should only include those managed by the organisation privilege.
 * Some fields such as Path, iden, should not be editable by organisation admins and thus are not returned here to avoid confusion.
 */
export const UPDATE_MUTATION = gql`
  mutation UpdateOrganisation($filter: FilterUpdateOneOrganisationInput, $record: UpdateOneOrganisationInput!) {
    saveItem: organisationUpdateOne(filter: $filter, record: $record) {
     recordId 
     record {
            name
            path
            isActive
            createdBy
            timeCreated
            logo
            archived
            _id
        }
    }
  }
`

/**
 * DELETE MUTATION
 */
export const DELETE_MUTATION = gql`
  mutation RemoveOrganisations($id: MongoID!) {
    organisationRemoveById(_id: $id){
    recordId
    }
  }
`
